module.exports = __webpack_public_path__ + "static/media/activities.5f2c2c00.svg";